import Cookies from 'js-cookie'
import config from '../config'

export const getUserPoints = async (userId) => {
  const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/wallets?userId=${userId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  }).then((res) => res.json())

  if (response.status.code !== 0) throw new Error(response.status.description)

  return response.data.balance
}

export const getUserTransactions = async (userId, page = 1, limit = 10) => {
  const params = new URLSearchParams({
    userId: userId,
    page: page,
    limit: limit,
  })

  const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/wallets/transactions?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  }).then((res) => res.json())

  if (response.status.code !== 0) throw new Error(response.status.description)

  return response
}
